import axios from "axios";

import {
  VOLUNTEER_APPLY_REQUEST,
  VOLUNTEER_APPLY_SUCCESS,
  VOLUNTEER_APPLY_FAIL,
} from "../constants/volunteerApplicationConstants";

//
//
//
export const apply = (application) => async (dispatch) => {
  try {
    dispatch({
      type: VOLUNTEER_APPLY_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.post(
      "/api/volunteers",
      { application },
      config,
    );

    dispatch({
      type: VOLUNTEER_APPLY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: VOLUNTEER_APPLY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
